import styled from "styled-components";
import { Element } from "../Element";
export const Divider = styled(Element).attrs({
  component: 'hr'
})`
  box-sizing: border-box;
`;